import { ChecklistItem } from './../builders/checklist_item_builder';
import { IDefineCommand, ICommand } from 'core-ts-types';

angular.module('capability-ng-checklist').factory(
  'udpateChecklistItemStatusCommand',
  (
    defineCommand: IDefineCommand,
    $q: ng.IQService,
    udpateChecklistItemStatusServerCommand: ICommand,
    udpateChecklistItemStatusLocalCommand: ICommand
  ): ICommand => {
    return defineCommand(
      'udpateChecklistItemStatusCommand',
      (deferred: ng.IDeferred<void>, item: ChecklistItem, newStatus: string) => {
        return $q.all([
          udpateChecklistItemStatusServerCommand(item, newStatus),
          udpateChecklistItemStatusLocalCommand(item, newStatus)
        ]);
      }
    );
  }
);



// WEBPACK FOOTER //
// ./app/lib/checklist/commands/update_checklist_item_status_command.ts